import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { otpValidation } from 'src/app/models/otpValidation.model';
import { AccountService } from 'src/app/services/account.service';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-otpverification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
})
export class VerificationComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  otp: string = '';
  otpVerificationScreen: boolean = false;
  otpValidationModel: otpValidation = new otpValidation();
  mobileNumber: any = '';
  maskedAccountNo: string = '';
  token: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '●',
    inputStyles: {
      width: '36px',
      height: '36px',
    },
  };
  showSubscriptionTemplate: boolean = false;
  showSuccessTemplate: boolean = false;
  sku: any;
  additionalBenefits: any;
  howtoSubscribe: any;
  termsCondition: any;
  main: any;
  addon: string = '';
  hiddenHeader: boolean;
  categoryDetail: any;
  categoryName: string;
  isArabic: boolean;
  showOTPError = true;
  OTPErrorMSG: any;
  enableResendcode: boolean = false;
  mobileErrorMSG: any;
  showMobileErrorMSG = false;
  showErrorTemplate: boolean;
  ismobileScreen: boolean;
  VerificationTemplate = false;
  loadingCompleted = false;
  language: string;
  userData: any;
  userLoggedIn: boolean;
  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private SDS: SessionDataService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private AS: AccountService,
    private router: Router
  ) {

    this.SS.resetVerification.subscribe((r) => {
      if (r) {

        this.VerificationTemplate = false;
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = false;
        this.showErrorTemplate = false;
      }
    })
  }

  // ngDestory() {
  //   this.showSubscriptionTemplate = false;
  //   this.showSuccessTemplate = false;
  //   this.hiddenHeader = false;
  //   this.SS.addonBuySuccessfully.unsubscribe();
  // }

  ngOnInit() {
    this.getUserInfo();
    this.VerificationTemplate = false;
    const w = document.documentElement.clientWidth || window.innerWidth;
    if (w < 992) {
      this.ismobileScreen = true;
    } else {
      this.ismobileScreen = false;
    }
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.SS.addonBuySuccessfully.subscribe((r) => {
      if (r && r.success == true) {
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = true;
        this.hiddenHeader = true;
      }
      if (r && r.success == false) {
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = true;
        this.showErrorTemplate = true;
      }
    });
    setTimeout(() => {
      // this.sku = this.SKUDS.get();
      // this.addon = this.SDS.getAddon();
      this.showSubscriptionTemplate = false;
      this.showSuccessTemplate = false;
      this.hiddenHeader = false;
      this.showErrorTemplate = false;
     // this.getSKUDetails();
      this.cdr.detectChanges();
      // this.SS.sku.subscribe((main) => {
      //   if (main && main.name) {
      //     this.addon = main.name;
      //   }
      //   if (main && main.value) {
      //     this.categoryDetail = main.value;
      //   }
      //   if (main && main.value && main.value.currentCategory) {
      //     this.categoryName = main.value.currentCategory;
      //   }
      //   this.cdr.detectChanges();
      // });
      this.SS.currentAccount.subscribe((r) => {
        if ((r && r.mobileNumber) || (r && r.accountNo)) {
          this.SS.account.next(
            r.mobileNumber ? r.mobileNumber : r.accountNo ? r.accountNo : ''
          );
          this.showSubscriptionTemplate = true;
        }
      });
      setTimeout(() => {
        this.loadingCompleted = true;
      }, 500);
    }, 500);
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController
      .dismiss({
        dismissed: true,
      })
      .then(() => {
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = false;
        // this.SS.addonBuySuccessfully.unsubscribe();
        this.UTS.clearError();
        this.cdr.detectChanges();
      });
  }

  getOTP() {
    // if(this.enableResendcode == false){
    //   return false;
    // }
    this.mobileErrorMSG = '';
    this.ngOtpInput.setValue(null);
    this.UTS.clearError();
    this.productService.getMobileEligibility(this.mobileNumber).subscribe(
      (resp) => {
        if (resp.status == 1) {
          //&& resp.accountId remove account ID for non logged in customer
          this.productService.generateOTP(this.mobileNumber).subscribe(
            (resp) => {
              this.maskedAccountNo = resp.maskedAccountNo;
              this.token = resp?.token;
              this.otpVerificationScreen = true;
              setTimeout(() => {
                this.cdr.detectChanges();
                this.resendCodeTimer();
              }, 500);
            },
            (e) => {
              // this.UTS.error(e.error.message);
              this.mobileErrorMSG = e.error.message;
              if (e.error.message == "NO_ACCOUNT_EMAIL_FOR_ELIFE_NUMBER") {
                let errorTitle = 'Invalid number';
                let errorMessage =
                  'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
                if (this.isArabic) {
                  errorTitle = 'الرقم غير صحيح';
                  errorMessage =
                    'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
                }
                this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
              }
            }
          );
        } else {
          let errorTitle = 'Invalid number';
          let errorMessage =
            'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
        }
      },
      (e) => {
        this.mobileErrorMSG = e.error.message;
      }
    );
  }

  onMobileKeyPress($event) {
    this.mobileErrorMSG = '';
    return (
      ($event.charCode != 8 && $event.charCode == 0) ||
      ($event.charCode >= 48 && $event.charCode <= 57)
    );
  }
  resendOTP() {
    if (this.enableResendcode == false) {
      return false;
    }
    this.mobileErrorMSG = '';
    this.ngOtpInput.setValue(null);
    this.showOTPError = false;
    this.UTS.clearError();
    this.productService.getMobileEligibility(this.mobileNumber).subscribe(
      (resp) => {
        if (resp.status == 1) {
          //&& resp.accountId remove account ID for non logged in customer
          this.productService.generateOTP(this.mobileNumber).subscribe(
            (resp) => {
              this.maskedAccountNo = resp.maskedAccountNo;
              this.token = resp?.token;
              this.otpVerificationScreen = true;
              setTimeout(() => {
                this.cdr.detectChanges();
                this.resendCodeTimer();
              }, 500);
            },
            (e) => {
              this.mobileErrorMSG = e.error.message;
            }
          );
        } else {
          let errorTitle = 'Invalid number';
          let errorMessage =
            'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
        }
      },
      (e) => {
        this.mobileErrorMSG = e.error.message;
      }
    );
  }

  changeOTP(otp: string) {
    this.showOTPError = false;
    this.otp = otp;
  }

  validateOtp() {
    this.showOTPError = false;
    this.UTS.clearError();
    this.otpValidationModel.accountNo = this.mobileNumber;
    this.otpValidationModel.authValue = this.otp;
    this.otpValidationModel.authType = 'otp';
    this.otpValidationModel.token = this.token;
    this.productService.validateOTP(this.otpValidationModel).subscribe(
      (resp) => {
        this.showOTPError = false;
        if (resp.success) {
          this.SS.account.next(this.mobileNumber);
          this.GAS.OTPVerification(this.categoryName, 'Submit');
          this.AAS.OTPVerification(this.categoryName, 'Submit');
          this.showSubscriptionTemplate = true;
          this.modalController.dismiss();
          setTimeout(() => {
            sessionStorage.setItem('mobileNumber',this.mobileNumber);
            sessionStorage.setItem('token',this.token);
            this.router.navigateByUrl('/create-request/personalInfo')
          }, 500);
        } else {
          this.translate.get('OTP_INVALID').subscribe((message) => {
            this.showOTPError = true;
            this.OTPErrorMSG = message;
          });
          this.GAS.OTPVerification(this.categoryName, 'Error');
          this.AAS.OTPVerification(this.categoryName, 'Error');
        }
      },
      (e) => {
        this.UTS.error(e.error.message);
      }
    );
  }
  sendBtnEnable() {
    const category = localStorage.getItem('CAT');
    if (this.mobileNumber && this.mobileNumber.length > 0) {
      if (
        category &&
        (category.toLocaleLowerCase() == 'cat550031' ||
          category.toLocaleLowerCase() == 'cat550030' ||
          category.toLocaleLowerCase() == 'cat550029')
      ) {
        if (this.mobileNumber.length > 8 && this.mobileNumber.length < 10) {
          return true;
        } else {
          return false;
        }
      } else if (
        this.mobileNumber.length > 9 &&
        this.mobileNumber.length < 11
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  resendCodeTimer() {
    this.cdr.detectChanges();
    setTimeout(() => {
      // Set the date we're counting down to
    const d = new Date();
    //'Nov 18, 2021 11:29:00'
    const timer =
      d.getFullYear() +
      '-' +
      Number(Number(d.getUTCMonth()) +
        1) +
      '-' +
      d.getDate() +
      ' ' +
      d.getHours() +
      ':' +
      (d.getMinutes() + 2) +
      ':' +
      d.getSeconds();
    let countDownDate = new Date(timer.replace(/-/g, "/")).getTime();
    // Update the count down every 1 second

    this.enableResendcode = false;
    let x = setInterval(() => {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days: any = Math.floor(distance / (1000 * 60 * 60 * 24));
      days = days < 10 ? '0' + days : days;
      let hours: any = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      hours = hours < 10 ? '0' + hours : hours;
      let minutes: any = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      minutes = minutes < 10 ? '0' + Number(minutes) : Number(minutes);

      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      seconds = seconds < 10 ? '0' + Number(seconds) : Number(seconds);
      // Output the result in an element with id="demo"
      //days + ':' + hours + ':' +
      const timer = minutes + ':' + seconds + '';
      if (
        document.getElementById('reSendOtpTimer') &&
        document.getElementById('reSendOtpTimerInSeconds')
      ) {
        document.getElementById('reSendOtpTimer').innerHTML =
          minutes + ':' + seconds + '';
        document.getElementById('reSendOtpTimerInSeconds').innerHTML =
          Number(minutes * 60) + Number(seconds) + '';
        if (document.getElementById('reSendOtpTimer2') && seconds >= 0) {
          document.getElementById('reSendOtpTimer2').innerHTML =
            minutes + ':' + seconds + '';
        }
        this.cdr.detectChanges();
      } else {
        clearInterval(x);
      }

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        this.enableResendcode = true;
      }
    }, 1000);
    }, 500);
  }


  getUserInfo() {
    this.language = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r) {
          this.userData = r;
          this.userLoggedIn = true;
        }
      },
      () => {
        this.userLoggedIn = false;
      }
    );
  }
}
